import React from "react";
import { useMediaQuery } from "@mui/material";
import CheckIcon from "/Images/cekidot.svg";
import DeployImage from "/Images/DigitalAsset.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import UnderstandingIcon1 from "/Images/icondigital1.svg";
import UnderstandingIcon2 from "/Images/icondigital2.svg";
import UnderstandingIcon3 from "/Images/icondigital3.svg";

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E7E4E2",
      padding: isMobile ? "50px 20px" : "100px",
      borderRadius: "10px",
    },
    imageContainer: {
      flex: 1,
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-start",
      alignItems: "center",
      marginBottom: isMobile ? "20px" : "0",
    },
    image: {
      width: isMobile ? "80%" : "90%",
      borderRadius: "10px",
    },
    textContainer: {
      paddingRight: isMobile ? "0" : "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      textAlign: "left",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "20px" : "30px",
      fontWeight: "600",
      marginBottom: "40px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      marginBottom: "20px",
      justifyContent: "flex-start",
      maxWidth: isMobile ? "100%" : "600px",
    },
    listIcon: {
      height: isMobile ? "30px" : "40px",
      marginTop: "4px",
    },
    listTitle: {
      fontWeight: "600",
      fontSize: isMobile ? "0.9rem" : "1rem",
      color: "#214D73",
      marginBottom: "4px",
    },
    listDescription: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      color: "#6D6D6D",
      lineHeight: "1.5",
      margin: 0,
      textAlign: "justify",
    },
    arrow: {
      marginLeft: "10px",
      backgroundColor: "#2D669B",
      borderRadius: "50%",
      padding: "5px",
      color: "#F4E37B",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.imageContainer}>
        <img src={DeployImage} alt="Deployment" style={styles.image} />
      </div>
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Advantages for
          Buyers & Sellers
        </h2>

        <div style={styles.listItem}>
          <img src={UnderstandingIcon1} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>Safe, Secure & No Advance Crypto Escrow Transaction Risk</span>
            <p style={styles.listDescription}>
              The buyer can verify the quality before the seller receives crypto escrow transaction.
              The seller does not receive funds until the buyer has securely deposited
              them in the protected Xcrow account.
            </p>
          </div>
        </div>

        <div style={styles.listItem}>
          <img src={UnderstandingIcon2} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>Fair & Transparent</span>
            <p style={styles.listDescription}>
              A structured process ensures fair handling. Fraud is excluded, as no goods
              are delivered or funds released without mutual consent.
            </p>
          </div>
        </div>

        <div style={styles.listItem}>
          <img src={UnderstandingIcon3} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>International</span>
            <p style={styles.listDescription}>
              Seamless cooperation across international borders.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeploymentSection;
